<template>
  <div>

    <van-cell-group>
      <van-cell title="订单-收入" :value="item.price" v-for="(item, index) in list" :key="index" />
    </van-cell-group>

    <Floating />
    <wxNoShare />
  </div>
</template>

<script>
  import { Cell, CellGroup } from 'vant'

  export default {
    components: {
      [Cell.name]: Cell,
      [CellGroup.name]: CellGroup,
    },
    name: 'income',
    data () {
      return {
        list: []
      }
    },
    created () {
      this.getData()
    },
    methods: {
      getData() {
        this.$api.get('orders/income', null, r=>{
          this.list = r.data
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/users/income.vue